import * as React from 'react';

import Typography from 'shared/newComponents/Typography';
import {
  TypographyColor,
  TypographySize,
  TypographyType,
  TypographyWeight
} from 'shared/newEntities/components/Typography';
import Avatar from 'shared/newComponents/user/Avatar';
import {
  AvatarSize,
  AvatarType
} from 'shared/newEntities/components/user/Avatar';

import './UserInfo.modules.scss';

type Props = {
  name: string | null;
  email: string;
};

const UserInfo: React.FC<Props> = ({ name, email }: Props) => {
  return (
    <div styleName="user-info">
      <Avatar type={AvatarType.name} content={name ?? ''} size={AvatarSize.m} />
      <div styleName="user-info__data">
        <Typography
          styleName="user-info__name"
          fontType={TypographyType.text}
          fontSize={TypographySize.s}
          fontWeight={TypographyWeight.semiBold}
          fontColor={TypographyColor.secondary}
        >
          {name}
        </Typography>
        <Typography
          styleName="user-info__email"
          fontType={TypographyType.text}
          fontSize={TypographySize.s}
          fontColor={TypographyColor.tertiary}
        >
          {email}
        </Typography>
      </div>
    </div>
  );
};

export default React.memo(UserInfo);
